import { OVER_AVERAGE_TYPING_THROTTLE_TIME } from 'hooks/useDelayedState';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData/hooks';
import { useCampaignGroupEnabled } from '../../../../campaigns-group-form/hooks/useCampaignGroupEnabled';
import { useCampaignBudgetRestrictions } from '../../BudgetSectionSponsored/hooks/useCampaignBudgetRestrictions';
import { useSpendingLimitOptions } from './useSpendingLimitOptions';

export const useBudgetFormFieldValue = () => {
    const isNoneSpendingLimitDisplayed = useSpendingLimitOptions();
    const campaignGroupExtensionEnabled = useCampaignGroupEnabled();
    const { campaignGroup } = useCampaignBudgetRestrictions();
    const fieldProps = useFormFieldValue(
        { field: 'budget', throttleValue: true, throttleTiming: OVER_AVERAGE_TYPING_THROTTLE_TIME },
        { isNoneSpendingLimitDisplayed, campaignGroupExtensionEnabled, campaignGroup }
    );
    return fieldProps;
};
